"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var menuItemConfig_1 = require("../menuItemConfig");
exports.default = new menuItemConfig_1.BaseMenuItemConfiguration({
    consumable: false,
    filters: [
        {
            name: 'type',
            options: constants_1.COUPON_TYPES,
            type: 'Select',
        },
        {
            name: 'promotional',
            type: 'Boolean',
        },
    ],
    hasDescription: true,
    hasHours: true,
    hasImage: false,
    hasVariations: false,
    hasPos: false,
    lists: [
        {
            collection: 'Category',
            name: 'redeemableCategories',
        },
        {
            collection: 'Item',
            name: 'redeemableItems',
        },
        {
            collection: 'Category',
            name: 'purchaseableCategories',
        },
        {
            collection: 'Item',
            name: 'purchaseableItems',
        },
    ],
    name: 'Coupon',
    options: {
        amount: 0,
        campaign: null,
        code: '',
        end: null,
        maxQuantity: null,
        min: 0,
        promotional: false,
        resetPeriod: null,
        start: null,
        type: 'ticket-percent',
    },
    pluralizedName: 'Coupons',
    sellable: false,
    sortKeys: ['amount'],
    unlinkedOptions: [],
    version: 8,
});
//# sourceMappingURL=coupon.js.map